import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepConnector from '@mui/material/StepConnector';
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import Typography from '@mui/material/Typography';
import { QuestionPhase } from '../constants';
import { useTranslation } from 'react-i18next'

export default function ProgressBar({ status }) {

  const { t, i18n } = useTranslation('translation');

  const steps = [
    {
      label: t("Broad project activities"),
      description: t("Select the broad planned activities associated with your mining project to narrow down to relevant pieces of legislation.")
    },
    {
      label: t("Detailed project activities"),
      description: t("Select detailed planned activities associated with your mining project to help determine which approvals may be required. The length of time required to complete this step will vary depending upon the activities selected from Step 1 and upon which series of questions you decide to answer in this Step.")
    },
    {
      label: t("Results"),
      description: t("A list of detailed results achieved through responding to the question in Step 2.")
    }
  ];

  const handleStep = (status) => {
    switch (status) {
      case QuestionPhase.ACTIVITYSELECT:
        return 0;
      case QuestionPhase.LEGISLATIONS:
      case QuestionPhase.SUBQUESTIONS:
        return 1;
      case QuestionPhase.RESULTS:
        return 2;
      default:
        return 0;
    }
  };

  return (
    <Box sx={{ width: '100%', py: 1 }}>
      <Stepper
        activeStep={handleStep(status)}
        alternativeLabel
        connector={
          <StepConnector
            sx={{
              '& .MuiStepConnector-line': {
                borderTopWidth: 4,
                borderColor: '#bdbdbd',
              },
              '&.Mui-completed .MuiStepConnector-line': {
                borderColor: '#2e7d32',
              },
              '&.Mui-active .MuiStepConnector-line': {
                borderColor: '#2e7d32',
              },
            }}
          />
        }
        sx={{
          width: '100%',
          '& .MuiStepIcon-root': {
            color: '#bdbdbd',
            fontSize: '3rem',
          },
          '& .MuiStepIcon-root.Mui-active': {
            color: '#2e7d32',
          },
          '& .MuiStepIcon-root.Mui-completed': {
            color: '#2e7d32',
          },
          '& .MuiStepLabel-label': {
            fontSize: '1.5rem',
          },
          '& .MuiStepLabel-iconContainer': {
            transform: 'scale(1.2)',
          },
        }}
      >
        {steps.map((step, index) => (
          <Step key={step.label}>
            <StepLabel>
              <Box sx={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography component="span" sx={{ fontSize: '1.5rem' }}>
                  {step.label}
                </Typography>
                <Tooltip
                  title={<Typography sx={{ fontSize: '1.25rem' }}>{step.description}</Typography>}
                  arrow
                  placement="top"
                  enterTouchDelay={0} leaveTouchDelay={4000}
                >
                  <InfoIcon sx={{ fontSize: 20, color: '#666', ml: 0.5 }} />
                </Tooltip>
              </Box>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}

{/* <Step key={step.label}>
            <Tooltip 
              title={step.description} 
              arrow 
              placement="top" 
              componentsProps={{
                tooltip: {
                  sx: {
                    fontSize: '1rem',
                  }
                }
              }}
            
              >
              <StepLabel>{step.label}</StepLabel>
            </Tooltip>
          </Step> */}

{/* <Step key={step.label}>
<StepLabel>
  <Box sx={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
    <Typography component="span" sx={{ fontSize: '1.25rem' }}>
      {step.label}
    </Typography>
    <Tooltip
      title={<Typography sx={{ fontSize: '0.95rem' }}>{step.description}</Typography>}
      arrow
      placement="top"
    >
      <InfoIcon sx={{ fontSize: 18, color: '#666', ml: 0.5 }} />
    </Tooltip>
  </Box>
</StepLabel>
</Step> */}
